import React, { useEffect, useState } from "react";
import {
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import DashboardStyle from "../../Styles/Dashboard.module.css";
import { FormatDateTime } from "../../../../utils/functions/ResourceFunctions";
import { toast } from "react-toastify";

function NeutralDocumentUploadComponent({
  onDocumentsChange,
  hasDocuments,
  name,
  id,
  title,
  defaultDocuments,
  disabled = false,
}) {
  const [vendorDocument, setVendorDocument] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
useEffect(() => {
defaultDocuments?.length > 0 &&  defaultDocuments?.forEach(dat => setVendorDocument([...vendorDocument, {...dat, fileUrl: dat?.base64Content}]))
// setVendorDocument([...defaultDocuments])
}, [defaultDocuments])
  useEffect(() => {
    // Notify parent component about document changes
    if (onDocumentsChange) {
      onDocumentsChange(vendorDocument);
    }
  }, [vendorDocument, onDocumentsChange]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Check file size: 500KB = 500 * 1024 bytes
      if (file.size > 500 * 1024) {
        toast.error("File size exceeds 500KB. Please select a smaller file.");
        e.target.value = ""; // Reset the input value
        return;
      }
      const newDocument = {
        file: file,
        fileName: file.name,
        fileType: file.type,
        fileUrl: URL.createObjectURL(file),
        uploadDate: new Date(),
      };
      setVendorDocument([...vendorDocument, newDocument]);
      setSelectedFile(null); // Clear the file input after upload
      e.target.value = ""; // Reset the input value
    }
  };

  const removeDocument = (index) => {
    const updatedDocuments = vendorDocument.filter((_, i) => i !== index);
    setVendorDocument(updatedDocuments);
    setSelectedFile(null); // Clear the file input if the document list is empty
  };

  return (
    <div>
      <section className={DashboardStyle.form_section}>
        <h4 className={DashboardStyle.form_section_title}>
          {title} <sup style={{ color: "red" }}>*</sup>
        </h4>
        {(!hasDocuments || !disabled) && (
          <TextField
            id={id}
            name={name}
            type="file"
            accept="*" // Accept all file types
            onChange={handleFileChange}
            value={selectedFile ? selectedFile.name : ""}
            disabled={disabled}
          />
        )}
      </section>

      <section className={DashboardStyle.form_section}>
        <h4 className={DashboardStyle.form_section_title}>
          {title} <br /> Upload
        </h4>
        <div
          className={`${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads}`}
        >
          {vendorDocument.length === 0 ? (
            <p>No Record Available</p>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>File Name</TableCell>
                  <TableCell>File Type</TableCell>
                  <TableCell>Date Uploaded</TableCell>
                  <TableCell>Preview</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {vendorDocument.map((doc, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{doc.fileName}</TableCell>
                    <TableCell>{doc.fileType}</TableCell>
                    <TableCell>
                      {FormatDateTime(doc.uploadDate, "DD/MM/YYYY")}
                    </TableCell>
                    <TableCell>
                      {doc.fileUrl && (
                        <Tooltip title="View Image">
                          <IconButton
                            component="a"
                            href={doc.fileUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        color="secondary"
                        onClick={() => removeDocument(index)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </section>
    </div>
  );
}

export default NeutralDocumentUploadComponent;
